import React from 'react';
import PropTypes from 'prop-types';
import { Form, Table } from 'react-bootstrap';
import WordCountIndicator from './WordCountIndicator';

const MemberAttendanceTable = ({
  members,
  isEditable,
  hasFieldError,
  getAttendanceStatus,
  onChange,
  fieldPrefix = '',
}) => (
  <Form.Group className="mb-5" id={`field-${fieldPrefix}memberAttendance`}>
    <Form.Label className="fw-bold">
      Committee Members and Conflicts of Interest
    </Form.Label>
    {isEditable && (
      <Form.Text className="d-block text-muted mb-2">
        Please confirm member attendance and participation in the evaluation
        process (where permissible under the conflict-of-interest rules), and
        how direct and indirect conflicts were handled.
      </Form.Text>
    )}
    <Table bordered responsive className="mb-0">
      <thead>
        <tr className="bg-light">
          <th style={{ width: '30%' }}>SC Members</th>
          <th style={{ width: '70%' }}>
            Member attendance and contributions to scoring
          </th>
        </tr>
      </thead>
      <tbody>
        {members.map((member, index) => {
          const hasError = hasFieldError(`attendance-${index}`);
          const status = getAttendanceStatus(index);
          return (
            <tr key={member.userId || index}>
              <td className="align-middle">
                {member.memberName}
                {member.role === 'Chair' && (
                  <span className="ms-1">(Chair)</span>
                )}
              </td>
              <td id={`field-${fieldPrefix}attendance-${index}`}>
                {isEditable ? (
                  <>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={member.attendance ?? ''}
                      onChange={(e) => onChange(index, e.target.value)}
                      placeholder="Attendance and contributions..."
                      autoComplete="off"
                      name={`attendance-${index}`}
                      className={hasError || status.over ? 'border-danger' : ''}
                    />
                    <WordCountIndicator
                      count={status.count}
                      limit={status.limit}
                      over={status.over}
                    />
                    {hasError && !status.over && (
                      <div className="text-danger small mt-1">
                        <i className="fas fa-exclamation-circle me-1" />
                        Required field
                      </div>
                    )}
                  </>
                ) : (
                  <div className="ps-2" style={{ whiteSpace: 'pre-wrap' }}>
                    {member.attendance?.trim() || (
                      <span className="text-muted fst-italic">—</span>
                    )}
                  </div>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  </Form.Group>
);

MemberAttendanceTable.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      memberName: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      attendance: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isEditable: PropTypes.bool.isRequired,
  hasFieldError: PropTypes.func.isRequired,
  getAttendanceStatus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldPrefix: PropTypes.string,
};

export default MemberAttendanceTable;
